import pinterpolate from 'pinterpolate';
import type { ServiceId, ServiceParams } from 'interface/service';

import http from 'utils/http';
import config from '../config';

import { PAGE_SIZE } from 'constants/appConstants';

export async function fetchUserFeedbacks(userId: ServiceId, params: ServiceParams) {
  const url = `${config.jumpBaseURI}${pinterpolate(config.endpoints.jump.userFeedbacks, { userId })}`;
  const { data } = await http.get(url, { params: { ...params, pageSize: PAGE_SIZE.MAX } });

  return data;
}

export async function fetchGoalFeedbacks(goalId: ServiceId, params: ServiceParams) {
  const url = `${config.jumpBaseURI}${pinterpolate(config.endpoints.jump.goalFeedbacks, { goalId })}`;
  const { data } = await http.get(url, { params: { ...params, pageSize: PAGE_SIZE.MAX } });

  return data;
}
